var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var NotificationMessage_1;
import { Global } from "js-vextensions";
import { RunInAction } from "mobx-graphlink";
import { g } from "../../PrivateExports.js";
import { wvc_store } from "../../Store/WVCStore.js";
let NotificationMessage = NotificationMessage_1 = class NotificationMessage {
    constructor(text, pinnedFor) {
        this.id = ++NotificationMessage_1.lastID;
        this.text = text;
        if (pinnedFor) {
            this.pinnedTill = Date.now() + pinnedFor;
        }
    }
};
NotificationMessage.lastID = -1;
NotificationMessage = NotificationMessage_1 = __decorate([
    Global
], NotificationMessage);
export { NotificationMessage };
/** Helper, which tries to add a notification-message to the store, but if that fails, falls back to an alert. (useful, eg. in Start_0.ts) */
export function AddNotificationMessage(message, pinnedFor) {
    RunInAction("WVC.PostHandleError", () => {
        var _a;
        try {
            wvc_store.notificationMessages.push(new NotificationMessage(message, pinnedFor));
        }
        catch (ex) {
            g.alertCount_notifications = ((_a = g.alertCount_notifications) !== null && _a !== void 0 ? _a : 0) + 1;
            if (g.alertCount_notifications <= 2) {
                alert(message);
            }
            else {
                console.error(message);
            }
        }
    });
}
G({ AddNotificationMessage });
//# sourceMappingURL=NotificationMessage.js.map